import { render, staticRenderFns } from "./FranchiseeList.vue?vue&type=template&id=24b3c377&"
import script from "./FranchiseeList.vue?vue&type=script&lang=js&"
export * from "./FranchiseeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports